import {
  invoiceItemGrid,
  postInvoiceItemTypes,
  dropDown,
  targetInvoiceItemTypes,
  updateInvoiceItemTypes,
} from './interfaces'
import { DateFormatter, DateFormatterReverse } from '../data/helper'
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

const dateFormatter = new DateFormatter()

//#region submitInvoiceItem
export const submitInvoiceItem = async (invoiceItem: postInvoiceItemTypes) => {
  const token = localStorage.getItem('authToken')
  console.log("Step 1: Succesfully hit post to Portal")

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/InvoiceItem`,
    method: 'post',
    data: {
      jobId: invoiceItem.jobId,
      description: invoiceItem.description,
      orderNo: invoiceItem.orderNo,
      itemValue: invoiceItem.itemValue,
      //taxCodeId: invoiceItem.taxCodeId,
      //nominalCode: invoiceItem.nominalCode,
      invoiceId: invoiceItem.invoiceId,
      itemDate: invoiceItem.itemDate,
      xeroDepartmentId: invoiceItem.xeroDepartmentId,
      xeroTaxRateId: invoiceItem.xeroTaxRateId,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((response) => {
    console.log("Step 2: Succesfully added job to portal")
    const data: postInvoiceItemTypes = response.data

    const invoiceitemId = data.invoiceitemId

    console.log(`Step 3: Invoice item id: ${invoiceitemId}`)

      if (invoiceitemId) {
        /*
        console.log("Step 4: Posting to sage")
        addInvoiceItemToSage(invoiceitemId).then((response) => {
          console.log("Step 5: Finished posting")
        }).catch((error) => {
          console.log(error)
          console.log("An error occured")
        });
        */
        console.log("Step 6: Moving onto next stage")
      } else {
        console.log("Error theres no ID")
        throw new Error('Invoice item not found in response');
      }

    return data
  });

}
//#endregion

//#region addInvoiceItemToSage
/*
export const addInvoiceItemToSage = async (invoiceItemId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    
    url: `https://${apiURL}/InvoiceItem/AddToSage/${invoiceItemId}`,
    method: 'post',
    
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

//#region updateInvoiceItem
export const updateInvoiceItem = async (invoiceItem: updateInvoiceItemTypes, invoiceItemId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/InvoiceItem/${invoiceItemId}`,
    method: 'put',
    data: {
      invoiceItemId: invoiceItem.invoiceitemId,
      jobId: invoiceItem.jobId,
      description: invoiceItem.description,
      orderNo: invoiceItem.orderNo,
      itemValue: invoiceItem.itemValue,
      taxCodeId: invoiceItem.taxCodeId,
      nominalCode: invoiceItem.nominalCode,
      invoiceId: invoiceItem.invoiceId,
      xeroDepartmentId: invoiceItem.xeroDepartmentId,
      xeroTaxRateId: invoiceItem.xeroTaxRateId,      
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  });

  const data: updateInvoiceItemTypes = response.data

  const invoiceitemId = data.invoiceitemId

  //updateInvoiceItemToSage(invoiceitemId);

  return data
}
//#endregion

//#region updateInvoiceItemToSage
/*
export const updateInvoiceItemToSage = async (invoiceItemId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    
    url: `https://${apiURL}/InvoiceItem/UpdateToSage/${invoiceItemId}`,
    method: 'post',
    
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

//#region deleteInvoiceItem
export const deleteInvoiceItem = async (invoiceItemId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/InvoiceItem/${invoiceItemId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data
}
//#endregion

//#region deleteInvoiceItemFromSage
/*
export const deleteInvoiceItemFromSage = async (invoiceItemId: number, invoiceRef: number) => {
  const token = localStorage.getItem('authToken')

  

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/InvoiceItem/DeleteFromSage/${invoiceItemId}_${invoiceRef}`,
    // data: invoiceRef,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data
}
  */
//#endregion

//#region getTargetInvoiceItem
export const getTargetInvoiceItem = async (invoiceItemId: number): Promise<targetInvoiceItemTypes> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/InvoiceItem/${invoiceItemId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: targetInvoiceItemTypes = response.data

  const targetInvoiceItemData: targetInvoiceItemTypes = {
    invoiceitemId: data.invoiceitemId,
    invoiceRef: data.invoiceRef,
    jobId: data.jobId,
    jobRef: data.jobRef,
    jobRefFormatted: data.jobRefFormatted,
    departmentId: data.departmentId,
    department: data.department,
    description: data.description,
    orderNo: data.orderNo,
    itemDate: data.itemDate,
    itemValue: data.itemValue,
    invoiceTaxcodeId: data.invoiceTaxcodeId,
    invoiceTaxcode: data.invoiceTaxcode,
    vatValue: data.vatValue,
    nominalCode: data.nominalCode,
    invoiceId: data.invoiceId,
    xeroDepartmentId: data.xeroDepartmentId,
    xeroTaxRateId: data.xeroTaxRateId
  }

  return targetInvoiceItemData
}
//#endregion


export interface XeroDepartments {
  disabled: boolean
  group: {
    disabled: boolean
    name: string    
  }
  selected: boolean
  text: string
  value: string
}

export const getXeroDepartments = async (): Promise<XeroDepartments[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/xerotrackingdepartment/ForDropDown`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data
}


export interface XeroTaxRates {
  disabled: boolean
  group: {
    disabled: boolean
    name: string    
  }
  selected: boolean
  text: string
  value: string
}

export const getXeroTaxRates = async (): Promise<XeroTaxRates[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/xerotaxrate/ForDropDown`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data
}
export interface XeroTaxRateWithRate {
  value: number
  text: string
  /** Percentage, e.g. 20 for standard-rate VAT. */
  rate: number
}

/** The Xero tax rates with their percentages, for working out an invoice's VAT. */
export const getXeroTaxRatesWithRates = async (): Promise<XeroTaxRateWithRate[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/xerotaxrate/WithRates`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}
